//Smooth Scroll
$(function(){

  var adjuster = 0;

  var scrollElm = (function () { //chrome対策
    if ('scrollingElement' in document) {
      return document.scrollingElement;
    }
    if (navigator.userAgent.indexOf('WebKit') != -1) {
      return document.body;
    }
    return document.documentElement;
  })();

  // Anchor Link (outpage)
  var hash = location.hash;
  if (hash && $(hash).length > 0) {
    adjuster = $(window).width() < 1080 ? $('#mainnav-head').innerHeight() : 0;
    var posY = Math.ceil($(location.hash).offset().top - adjuster);
    $(scrollElm).scrollTop(posY);
  }

  // Anchor Link (inpage)
  $('a[href^="#"]').on('click.scrl', function() {
    const scrlID = $(this).attr('href');
    $('html,body').animate({
      scrollTop: (scrlID === '#top') ? 0 : Math.ceil($(scrlID).offset().top - adjuster)
    }, 800, 'swing');
    return false;
  });

  // Adjuster height
  function setAdjusterHeight() {
    enquire.register('screen and (max-width: 1080px)', {
      match: function() {
        adjuster = $('#mainnav-head').innerHeight();
      },
      unmatch: function() {
        adjuster = 0;
      }
    });
  }
  setAdjusterHeight();

  var timer = 0;
  $(window).on('resize',function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      setAdjusterHeight();
    }, 200);
  });

});
